import LineCompassIcon from 'LuxKit/Icons/line/LineCompassIcon'
import TextLink from 'LuxKit/TextLink'
import React, { useCallback, useContext } from 'react'
import AdditionalWaysToExperienceMessagingTile from './AdditionalWaysToExperienceMessagingTile'
import ModalContext from 'contexts/ModalContext'
import PrivateRequestFormModal from 'components/OfferPage/TourV2/PrivateRequest/PrivateRequestFormModal'
import { OfferPageRoom } from 'contexts/OfferPage/offerPageStateReducer'

interface Props {
  offer: App.Tours.TourV2Offer
  defaultTravellers: Array<OfferPageRoom>
}

function PrivateDepartureMessagingTile({ offer, defaultTravellers }: Props) {
  const showModal = useContext(ModalContext)

  const requestPrivateTour = useCallback(() => {
    showModal(<PrivateRequestFormModal offer={offer} defaultTravellers={defaultTravellers} />)
  }, [showModal, offer, defaultTravellers])

  return <AdditionalWaysToExperienceMessagingTile
    heading="Private Departure"
    description="Travel exclusively with family and friends at a time that works best for you."
    Icon={LineCompassIcon}
    action={<TextLink size="small" onClick={requestPrivateTour}>Submit a request</TextLink>}
  />
}

export default PrivateDepartureMessagingTile
